<template>
  <v-container class="progress-container">
    <div class="progress-counter">
    <div class="progress-description" v-html="this.getBarDescription()">
    </div>
    <v-icon ml-1 small color="primary">favorite</v-icon>
    </div>

    <div v-if="showQuorum" class="quorumContainer">
      <div class="quorum" :style="{left: `${quorumPercent}%`}">

        <v-tooltip top>

          <div slot="activator">
            <div>{{ proVotes }}</div>
          <v-icon>mdi_arrow_downward</v-icon>
          </div>
          <span>{{ $vuetify.t('$vuetify.Idea.quorum') }}</span>
        </v-tooltip>
      </div>
    </div>

    <div class="bar" v-bind:class="{'small': !!this.small}">
      <div class="pro" :style="{right: this.proPercent? `${100-this.proPercent}%` : `100%`}"></div>
      <div class="contra" :style="{left: this.contraPercent? `${100-this.contraPercent}%` : `100%`}"></div>
    </div>

  </v-container>
</template>

<script>
import ideaApi from '@/api/idea'

import * as spaceApi from '@/api/ideaSpace'

export default {
  name: 'ProgressBar',
  props: {
    proVotes: Number,
    contraVotes: Number,
    idea: Object,
    showQuorum: Boolean,
    small: Boolean
  },
  data: function () {
    return {
      spaceSlug: 'school',
      quorum: {
        classQuorum: 30,
        schoolQuorum: 30,
        totalVoters: 0
      }
    }
  },
  beforeMount: function () {
    this.getSpaceInfo()
  },
  computed: {
    proPercent: function () {
      if (this.quorum.totalVoters === 0) {
        return 0
      }
      return 100 * Math.min(this.proVotes / this.quorum.totalVoters, 1)
    },
    contraPercent: function () {
      if (this.quorum.totalVoters === 0) {
        return 0
      }
      return 100 * Math.min(this.contraVotes / this.quorum.totalVoters, 1)
    },
    quorumPercent: function () {
      return 100 * Math.min(this.quorum.requiredVoteCount / this.quorum.totalVoters, 1)
    }
  },
  methods: {
    getBarDescription: function () {
      if (this.showQuorum) {
        return this.$vuetify.t('$vuetify.Idea.supporterCount', this.proVotes, this.quorum.totalVoters)
      }
      return this.$vuetify.t('$vuetify.Idea.votesCount', this.proVotes, this.contraVotes)
    },
    getSpaceInfo: function () {
      this.spaceSlug = this.$route.params['spaceSlug']
      let spaceId = this.$route.params['spaceId']
      if (this.spaceSlug !== 'school') {
        spaceApi.getSpace(this.$store.getters.selected_school, this.$route.params['spaceSlug'])
          .then((res) => {
            spaceId = res.data[0].id
            this.getQuorumInfo(spaceId)
          })
      } else {
        this.getQuorumInfo(spaceId)
      }
    },
    getQuorumInfo: function (ideaSpaceId) {
      ideaApi.getQuorumInfo(
        this.$store.getters.selected_school,
        ideaSpaceId
      ).then(resp => {
        this.quorum = resp.data
      })
    }
  }
}
</script>

<style lang="scss">
.progress-container{
     background-color: #eee;
     border-radius: var(--var-border-radius);
     margin-bottom: 1rem;
     padding: 1rem;

     .progress-counter {
      padding-bottom: 1rem;
      display: flex;

        .progress-description{
          padding: 0rem 0.3rem 0rem 0rem;

          .supportNum {
            color: var(--v-primary-base);
          }

          .againstNum {
            color: var(--v-secondary-base);
          }

          .neededNum {
            color: #777;
          }
        }
}
.bar{
  background: var(--v-warning-lighten5);
  border-radius: var(--var-border-radius);
  position: relative;
  height: 2rem;

  &.small{
    height: 1rem;
  }

  .pro{
    position: absolute;
    border-radius: var(--var-border-radius);
    top: 0;
    left: 0;
    bottom: 0;
    background-color: var(--v-primary-base);
    transition: right 0.5s;
  }
  .contra{
    position: absolute;
    border-radius: var(--var-border-radius);
    top: 0;
    right: 0;
    bottom: 0;
    background-color: var(--v-secondary-base);
    transition: left 0.5s;
  }

}

.quorumContainer{
  position: relative;

  .quorum{
    position: absolute;
    bottom: 0;
    $quorumHeight: 1.2rem;
    height: $quorumHeight;

    i{
      margin-left: -50%;
      font-size: $quorumHeight;
    }
  }
}

}
</style>
